import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    margin: '40px 40px 24px',
  },
  cardWrapper: {
    margin: '24px 40px 5px',
    padding: '20px',
  },
  formCardWrapper: {
    margin: '24px 40px 5px',
    padding: '20px',
    '@media (min-width: 960px)': {
      margin: '24px 40px 5px 0px'
    },
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
    marginRight: '5px'
  },
  subPageTitle: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '29px',
    marginRight: '5px'
  },
  bottomText: {
    color: '#F37320',
    fontSize: '14px',
    margin: '0 40px',
    padding: '5px'
  },
  formCardHeading: {
    color: '#F37320',
    backgroundColor: '#F7F7F7',
    fontSize: '14px',
    fontWeight: 600,
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'
  },
  buttons: {
    width: 'auto',
    minWidth: '150px',
    minHeight: '36px',
    margin: '10px 0'
  },
  formCardContent: {
    padding: '10px'
  },
  actionStyle: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 500,
    width: '100%'
  },
  mr2: {
    marginRight: '1rem',
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  fileUploadSpace: {
    border: '1px dashed #CECECE',
    borderRadius: '5px',
    width: '13em',
    minHeight: '14em',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    backgroundColor: '#F6F6F6',
  },
  uploadLabel: {
    color: '#0000008a',
    fontSize: '15px',
    marginBottom: '5px'
  },
  uploadText: {
    color: '#545456',
    fontSize: '11px',
    fontWeight: 'bold'
  },
  uploadHelperTextWrapper: {
    margin: '10px 0',
    textAlign: 'center'
  },
  uploadHelperText: {
    fontSize: '12px',
    color: '#545456',
    padding: '2px'
  },
  button: {
    marginRight: theme.spacing(1.5),
    textTransform: 'none',
    padding: '5px 30px'
  },
  approveButton: {
    color: '#FFFFFF',
    '&:hover': {
      background: '#F37320'
    }
  },
  rejectButton: {
    border: '0.800000011920929px solid #F37321',
    color: '#F37321',
    '&:hover': {
      background: '#FFFFFF'
    }
  },
  modalStatusText: {
    color: '#545456',
    fontSize: '20px',
    fontWeight: 600,
    textAlign: 'center',
    marginTop: '2rem'
  },
  modalErrorText: {
    color: '#565657',
    fontSize: '20px',
    fontWeight: 600,
    textAlign: 'center',
  },
  mr4: {
    marginRight: '10px'
  },
  uploadInput: {
    display: 'none'
  },
  uploadButton: {
    textAlign: 'center',
    minHeight: '36px',
    width: '10rem'
  },
  link: {
    color: '#026AE3',
    cursor: 'pointer'
  },
  sidInTable: {
    minWidth: 100,
    textAlign: 'center'
  },
  oidInTable: {
    minWidth: 100,
    wordBreak: 'break-word',
    textAlign: 'center',
  },
  idInTable: {
    minWidth: 145,
    wordBreak: 'break-word'
  },
  nameInTable: {
    minWidth: 200,
    wordBreak: 'break-word'
  },
  statusInTable: {
    minWidth: 210,
    wordBreak: 'break-word'
  },
  centerHeader: {
    textAlign: 'center'
  },
  listKey: {
    fontSize: '12px',
    color: '#939497'
  },
  listValue: {
    fontSize: '14px',
    color: '#545455',
    wordBreak: 'break-all'
  },
  applicationFile: {
    width: '30%',
    maxWidth: '220px',
    minWidth: '180px',
    minHeight: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: '1px dashed #70707089',
    opacity: 1,
    backgroundColor: '#F5F5F5',
    padding: '15px 20px',
  },
  fileHelperText: {
    color: '#545456',
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  fileName: {
    margin: '2px 0 5px 0',
    fontSize: '12px',
    textAlign: 'center',
    color: '#F37320',
    wordBreak: 'break-all'
  },
  fileEdit: {
    cursor: 'pointer'
  },
  viewFileName: {
    marginTop: 20,
    fontSize: '12px',
    textAlign: 'center',
    color: '#F37320',
    wordBreak: 'break-all'
  },
  siteDetail: {
    fontSize: '15px',
    color: '#545455'
  },
  error: {
    color: '#d32f2f',
    fontSize: '0.75rem'
  },
  center: {
    textAlign: 'center',
    wordBreak: 'break-all'
  },
  modalText: {
    color: '#565657',
    fontSize: '20px',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '2rem'
  },
  modalButton: {
    maxWidth: '150px',
  },
  downloadIcon: {
    verticalAlign: 'middle',
    marginRight: '5px',
    width: '18px'
  },
  customDot: {
    width: 10,
    height: 10,
    margin: '0 8px',
    color: '#7F7F7F',
    opacity: 0.5,
    backgroundColor: '#7F7F7F',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  customDotActive: {
    width: 20,
    height: 20,
    opacity: 1,
    margin: '0 8px',
    backgroundColor: '#F37320',
    borderRadius: '50%',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  stepperDots: {
    alignItems: 'center',
  },
  stepperContent: {
    padding: 16,
    textAlign: 'center',
    fontSize: '16px',
    color: '#000000',
  },
  stepperLink: {
    color: '#F37320',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  stepperNumberImg: {
    position: 'absolute',
    top: '20px',
    left: '20px',
  },
  stepperImg: {
    margin: '10px 50px',
    width: '100%',
    maxWidth: '250px',
    height: '165px',
  },
  secondaryText: {
    fontSize: '14px',
    color: '#000000',
    opacity: 0.5,
    textAlign: 'center'
  },
  headerNumber: {
    display: 'block',
    '@media (max-width: 600px)': {
      display: 'none'
    }
  },
  processCard: {
    minHeight: '280px',
    '@media (max-width: 600px)': {
      minHeight: '300px'
    }
  },
  stepperContainer: {
    boxShadow: '0px 2px 10px #3F434714',
    margin: '24px 40px',
    padding: '1px 20px 20px',
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  privacyPolicy: {
    color: '#026AE3',
    cursor: 'pointer',
    textDecoration: 'none'
  },
  siteDetailKey: {
    color: '#939497',
    fontSize: '14px',
  },
  siteDetailValue: {
    color: '#545455',
    fontSize: '16px'
  }
}))

export { useStyles }